<template>
    <v-card class="rounded-xl" elevation="0" outlined width="100%">
      <v-card-text>
        <Bar :data="data" :options="options" height="300"></Bar>
      </v-card-text>
    </v-card>
  </template>
  <script>
  import { Bar } from "vue-chartjs";
  import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale,
  } from "chart.js";
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );
  export default {
    name: "BarCard",
    mounted: function () {},
    components: { Bar },
    computed: {},
    props: {
      data: {
        type: Object,
        default: () => {
          return {
            labels: [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ],
            datasets: [
              {
                label: "Data One",
                backgroundColor: "#f87979",
                data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11],
              },
            ],
          };
        },
      },
      options: {
        type: Object,
        default: () => {
          return {
            plugins: {
              legend: {
                display: true,
              },
              title: {
                display: true,
                text: "Expense vs Earning",
              },
            },
            indexAxis:'y',
            responsive: true,
            maintainAspectRatio: false,
            barThickness:30,
            elements: {
                bar: {
                    borderWidth: 2,
                }
            },
            scales: {
                x: {
                    stacked: true,
                },
                y: {
                    stacked: true
                }
            }
          };
        },
      },
    },
    data() {
      return {};
    },
  };
  </script>
  